import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/dist/sweetalert2.min.css';


const toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    confirmButtonColor:'#caac80',
    timer: 3000,
    timerProgressBar: false,
    didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer);
        toast.addEventListener('mouseleave', Swal.resumeTimer);
    }
});

const validationToast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: true,
    confirmButtonColor:'#caac80',
    timer: false,
    timerProgressBar: false,
    didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer);
        toast.addEventListener('mouseleave', Swal.resumeTimer);
    }
});

const swalMessages = {
    methods: {
        $showLoadingMessage() {
            toast.fire({
                icon: 'info',
                title: 'Please Wait!',
                html: 'Your information is being updated',
            });
        },
        $showSuccessMessage(text = `Successfully submitted!`, title = `Success!`) {
            toast.fire({
                icon: 'success',
                title,
                text,
            });
        },

        $showInfoSwal(text = `This position already exists in the list`, title = `Please note!`) {
            toast.fire({
                icon: 'info',
                title,
                text,
            });
        },

        $showSuccessMessageDelete(text = `Successfully submitted!`, title = `Success!`) {
            toast.fire({
                icon: 'success',
                title:'Deleted!',
                text:'Your item has been deleted'
            });
        },
        $showErrorMessage(text = `Something went wrong!`, title = `Error!`) {
            toast.fire({
                icon: 'error',
                title,
                text,
            });
        },
        $showValidationErrorMessage( text = `Information is required or is not correct!`, title = `Your Information isn't valid!`,) {
            toast.fire({
                icon: 'error',
                title,
                text,
            });
        },
        $showValidationErrorMessageAll(errors, title = `Information is required!`) {
            toast.fire({
                icon: 'error',
                title,
                text: errors.join(', '),
            });
        },

        $showValidationErrorSwal(title = `Information is required!`) {
            toast.fire({
                icon: 'error',
                title,
            });
        },

        $showLoading() {
            Swal.fire({
                title: 'Loading...',
                showConfirmButton: false,
            });
        },
        $showConfirmMessage(text = 'Are you sure you would like to delete this item? This action can not be undone.', confirmButtonText = 'Yes, delete it!') {
            return new Promise((resolve, reject) => {
                this.$swal.fire({
                    icon: 'warning',
                    title: 'Are you sure?',
                    text,
                    confirmButtonText,
                    showCancelButton: true,
                    confirmButtonColor: '#007bff',
                    cancelButtonColor: '#d33',
                }).then((result) => {
                    if (result.isConfirmed) {
                        resolve(true);
                    } else {
                        reject(false);
                    }
                });
            });
        },

        $showToastSuccessMessage(text = `Successfully submitted!`, timer = 3000) {
            toast.fire({
                icon: 'success',
                title: text,
                timer,
            });
        },
        $showToastErrorMessage(text = `Something went wrong!`, timer = 3000) {
            toast.fire({
                icon: 'error',
                title: text,
                timer,
            });
        }
    }
};

export default swalMessages;
